module.exports = __webpack_public_path__ + "static/media/nutrition-hero.edbcecc0.jpg";